<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const RightIcon = getIcon("RightIcon");
</script>

{#if typeof RightIcon === 'string'}
	<img src={RightIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof RightIcon === 'function'}
	<svelte:component this={RightIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
